// extracted by mini-css-extract-plugin
module.exports = {"date":"ProcedureTableInfo_date__1IgPf","head":"ProcedureTableInfo_head__1i7u7"};